import React from "react";

import { FaMapMarkerAlt } from "react-icons/all";

export const MapMarker: React.FC<{
  lat: number;
  lng: number;
  text: string;
  aqi: number;
  selected?: boolean;
  onClick?: () => void;
}> = ({ text, selected, aqi, onClick }) => {
  return (
    <>
      <div
        className="hover:text-gray-800 text-transparent font-bold hover:shadow-lg text-center cursor-pointer "
        onClick={onClick}
      >
        <span
          className={`absolute rounded-full h-10 w-10 top-0 bg-transparent border-2 text-gray-200 border-white ${
            !!selected ? "animate-ping" : ""
          }`}
        ></span>
        <div
          className={`flex flex-row justify-center items-center z-10 rounded-full w-10 h-10 bg-[#8EBBED] text-gray-200 border-2 border-white ${
            !!selected ? "" : ""
          }`}
          style={{ background: "#8EBBED" }}
        >
          <p className="-pt-1 text-gray-900">{aqi}</p>
        </div>
        {text}
      </div>
    </>
  );
};

export const MapMarkerMemoized = React.memo(MapMarker);
